import type { ReactNode } from "react";

export interface SectionProps {
  className?: string;
  children?: ReactNode;
}

export const Section = (props: SectionProps) => {
  return (
    <section
      className={`section-shell w-full px-5 py-20 md:px-8 md:py-28 ${props.className || ""}`}
    >
      <div className="mx-auto max-w-6xl">{props.children}</div>
    </section>
  );
};
